import { kolleginButtonMobile, kolleginButtonPc } from "@modules/single-page/kollegin-link/templates"

const kolleginApiUrl: string = "https://www.kollegin.de/api/ladiesprofile?id="
const advertActions = (): HTMLElement | null => document.querySelector("#einzelansicht main .advert-actions")
const linkBarContainer = (): HTMLElement | null =>
    advertActions()?.querySelector(".link-bar:first-child")?.closest(".row") as HTMLElement | null

export function initKolleginLink(): void {
    const advertActionsContainer = advertActions()
    if (advertActionsContainer === null || linkBarContainer() === null) {
        return
    }

    const currentAuftragsProfilId = Number.parseInt(advertActionsContainer.dataset.profileId || "", 10)
    if (Number.isNaN(currentAuftragsProfilId)) {
        return
    }

    getKolleginLink(currentAuftragsProfilId)
}

function getKolleginLink(currentAuftragsProfilId: number): void {
    const kolleginApiEndpoint = `${kolleginApiUrl}${currentAuftragsProfilId}`

    fetch(kolleginApiEndpoint, {
        method: "GET",
        mode: "cors",
        credentials: "include",
    }).then(addKolleginButtonToPage)
}

async function addKolleginButtonToPage(kolleginData: Response): Promise<void> {
    await kolleginData.json().then((kolleginData): void => {
        if (!kolleginData || !("url" in kolleginData)) {
            return
        }

        SiteInfo.isMobileVersion ? addButtonToMobile(kolleginData.url) : addButtonToPc(kolleginData.url)
    })
}

function addButtonToMobile(kolleginUrl: string): void {
    if (kolleginButtonMobile === null) {
        return
    }

    const button = kolleginButtonMobile.cloneNode(true) as HTMLElement
    button.querySelector(".button-kollegin-link a")?.setAttribute("href", kolleginUrl)

    linkBarContainer()?.appendChild(button)
}

function addButtonToPc(kolleginUrl: string): void {
    if (kolleginButtonPc === null) {
        return
    }

    const button = kolleginButtonPc.cloneNode(true) as HTMLElement
    button.querySelector(".button-kollegin-link a")?.setAttribute("href", kolleginUrl)

    linkBarContainer()?.appendChild(button)
}
